// src/components/page/version/version.tsx
// Page publique /version : numéro de version, date de compilation, mode et commit.
// Ne demande aucune connexion et n'appelle aucune API : tout est figé dans le
// bundle par update_build.js au moment du build.

import React from 'react';
import { appVersion, appCommit, buildDate } from '../../../config/build_infos';
import { getMode } from '../../../config/app_config';

export const Version = () => (
  <div style={{
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#111', color: '#eee', fontFamily: 'system-ui, sans-serif',
  }}>
    <dl style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '8px 24px', margin: 0 }}>
      <dt style={{ opacity: 0.6 }}>Version</dt>
      <dd style={{ margin: 0 }} data-testid="version">{appVersion}</dd>
      <dt style={{ opacity: 0.6 }}>Compilé le</dt>
      <dd style={{ margin: 0 }} data-testid="build-date">{buildDate}</dd>
      <dt style={{ opacity: 0.6 }}>Mode</dt>
      <dd style={{ margin: 0 }}>{getMode()}</dd>
      <dt style={{ opacity: 0.6 }}>Commit</dt>
      <dd style={{ margin: 0, fontFamily: 'monospace' }}>{appCommit}</dd>
    </dl>
  </div>
);

export default Version;
